
import axios from '../config/axios';

export const url = '/api/contactoep9x4'


export const createcontactoep9x4 = ({
  token,
	nombren2be6,
	telefono09c7u,
	mensajenba8f,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombren2be6 && telefono09c7u && mensajenba8f ) {

    axios.post(`${url}//create/basic/6898f5b6d9a58bc9adfc305b`, {
		nombren2be6,
		telefono09c7u,
		mensajenba8f,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombren2be6) {
		reject({
			status: 'error',
			info: 'nombren2be6 no esta definido',
		});
	}  else if (!telefono09c7u) {
		reject({
			status: 'error',
			info: 'telefono09c7u no esta definido',
		});
	}  else if (!mensajenba8f) {
		reject({
			status: 'error',
			info: 'mensajenba8f no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

